function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#F1F7FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 14v-4h4v4h3l-5 5-5-5h3zM22 22.5H10v-2h12v2z",
  fill: "#29354C"
});

var SvgIconDownloadActive = function SvgIconDownloadActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CjxjaXJjbGUgY3g9IjE2IiBjeT0iMTYiIHI9IjE2IiBmaWxsPSIjRjFGN0ZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQgMTRWMTBIMThWMTRIMjFMMTYgMTlMMTEgMTRIMTRWMTRaIiBmaWxsPSIjMjkzNTRDIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjIgMjIuNUgxMFYyMC41SDIyVjIyLjVaIiBmaWxsPSIjMjkzNTRDIi8+Cjwvc3ZnPgo=";
export { SvgIconDownloadActive as ReactComponent };